module.exports = __webpack_public_path__ + "media/images/products/ht1/ht1-1-1000x1000-ab6e046f9899e992153b61b3da60d166.png";